import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./ResetPasswordPage.css"; // optional styling

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
    const [, setError] = useState("");
    const API_URL = process.env.REACT_APP_API_URL;

  const email = searchParams.get("email") || "";
  const token = searchParams.get("token") || "";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
        const res = await fetch(`${API_URL}/reset-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, token, newPassword }),
        });

      const data = await res.json();

      if (res.ok) {
        setMessage(data.message || "Password reset successful!");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setError(data.message || "Reset failed");
      }
    } catch {
      setError("Network error");
    }
  };

  return (
        <div className="reset-page">
            <div className="reset-form-wrapper">
                <img src="/eda_forgot_password.png" alt="Logo" className="reset-logo" />
                <h2 className="reset-heading">Reset Password</h2>
                <form onSubmit={handleSubmit} className="reset-form">
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit">Reset Password</button>
          {message && <p className="reset-error">{message}</p>}
          
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
